import { WidgetErrorModel } from '../models/widget-error.model';
import { WebGLErrorEnum } from '../models/webgl-error.enum';

// default config
export const defaultWebGLErrorConfig: WidgetErrorModel = {
  title: 'WebGL Error',
  description: `It appears your browser isn't supporting WebGL, the HTML standard used to view 3D graphics.`
};

// custom user defined messages based on web gl errors
export const webGLErrorConfig: { [key: string]: WidgetErrorModel } = {
  [WebGLErrorEnum.WebGLNotSupported]: {
    title: 'WebGL Unsupported',
    description: `It appears your browser isn't supporting WebGL, the HTML standard used to view 3D graphics.`
  }
};
